const githubLink="https://github.com/aayushpawar07";
const instaLink="https://instagram.com/ayushparadkar07";
const linkedInLink="https://www.linkedin.com/in/AayushParadkar/";
const twitterLink="https://twitter.com/AayushParadkar";
const emailLink="mailto:ayushparadkar4@gmail.com";

const profileLinks={
    githubLink,
    instaLink,
    linkedInLink,
    twitterLink,
    emailLink
}
const SocialData=profileLinks;
export default SocialData;

